const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Google Calendar Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('GcalResource', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/v3/google-calendar/:subresource/:user', null, {
    addToCalendar: {params: {subresource: 'add'}, method: 'POST', isArray: false},
    gcalPermissionLink: {params: {subresource: 'permission', user: ''}, method: 'POST', isArray: false},
  });

}]);